import React from 'react';
import ReactDOM from 'react-dom';
// import InputRange from 'react-input-range';

class RangeInput extends React.Component {
  constructor(props) {
    super(props);
    this.handleValueChange = this.handleValueChange.bind(this);
    this.initRange = this.initRange.bind(this);
  }
  componentDidMount() {
    this.initRange(this.props);
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.block.hasOwnProperty('selectedRangeType')) {
      if (nextProps.block.selectedRangeType === 'single') {
        this.slider.update({
          from: nextProps.values.max,
        });
      } else {
        this.slider.update({
          from: nextProps.values.min,
          to: nextProps.values.max,
        });
      }
    }
  }

  getHistogram(countEachMetaDataValue) {
    const bars = countEachMetaDataValue.map((item, index) => {
      const className = 'bar-chart__bar';
      return (
        <div className={className}
          key={'rangeinput-' + index}
          style={
            { height: item * 3 }
          }
        >
        </div>
      );
    });
    return (
      <div className="bar-chart">
        {bars}
      </div>
    );
  }

  initRange(props) {
    const self = this;
    const target = ReactDOM.findDOMNode(this);
    let fix = null;
    if (props.unitFix === 'postfix') {
      fix = props.unit ? ' ' + props.unit : '';
    } else {
      fix = props.unit ? props.unit + ' ' : '';
    }
    let type = null;
    if (this.props.block.hasOwnProperty('selectedRangeType')) {
      type = this.props.block.selectedRangeType;
    } else {
      type = 'single';
    };
    jQuery(target).ionRangeSlider({
      type,
      grid: true,
      min: Number(props.minvalue),
      max: Number(props.maxvalue),
      from: Number(props.values.min),
      to: Number(props.values.max),
      prefix: props.unitFix === 'prefix' ? fix : '',
      postfix: props.unitFix === 'postfix' ? fix : '',
      onFinish: self.handleValueChange,
    });
    this.slider = jQuery(target).data('ionRangeSlider');
  }
  handleValueChange(val) {
    if (this.props.block.selectedRangeType === 'single') {
      this.props.grabRangeSelectValue(0, val.from);
    } else {
      this.props.grabRangeSelectValue(val.from, val.to);
    }
  }
  render() {
    return (
        <input type="text" id={'rangeInput-' + this.props.block.uid} name="example_name" value="" />
    );
  }
}
RangeInput.propTypes = {
  'maxvalue': React.PropTypes.number,
  'minvalue': React.PropTypes.number,
  'values': React.PropTypes.object,
  'options': React.PropTypes.array,
  'grabRangeSelectValue': React.PropTypes.func,
  'block': React.PropTypes.object,
};
export default RangeInput;



/** WEBPACK FOOTER **
 ** ./assets/src/frontend/element/rangeinput.js
 **/